import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: '[app-objects-report]',
    templateUrl: './objects-report.component.html',
    styleUrls: ['./objects-report.component.css'],
    standalone: false
})
export class ObjectsReportComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "AnalyticReport" }));
  }
}
